module.exports = __webpack_public_path__ + "img/question.85f69fa3.svg";